export const languagesConstants = {
    LANGUAGES_PENDING  : 'LANGUAGES_PENDING',
    LANGUAGES_FULFILLED: 'LANGUAGES_FULFILLED',
    LANGUAGES_REJECTED : 'LANGUAGES_REJECTED',
};
